module.exports = __webpack_public_path__ + "img/progress-icon.65c0539d.svg";